import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    this.group1 = [];
    this.group2 = [];
  }

  show_preview() {
    const errorEl = this.element.querySelector('[data-anti-pattern-target="error"]');
    const list1 = this.element.querySelector('[data-anti-pattern-target="preview1"]');
    const list2 = this.element.querySelector('[data-anti-pattern-target="preview2"]');

    errorEl.innerHTML = '';
    list1.innerHTML = '药品组一：'
    list2.innerHTML = '药品组二：'

    this.group1.forEach((el) => {
      list1.innerHTML += el + ', '
    });
    this.group2.forEach((el) => {
      list2.innerHTML += el + ', '
    });
  }

  add(group, inputName) {
    const input = this.element.querySelector(`input[name="${inputName}"]`);
    const errorEl = this.element.querySelector('[data-anti-pattern-target="error"]');

    if (!input) {
      errorEl.innerHTML = `<p>找不到输入框</p>`
      return;
    }

    const medicine_name = input.value.trim();

    if (!medicine_name) {
      errorEl.innerHTML = `<p>请输入药名</p>`
      return;
    }

    fetch(`/medicines/get_by_name?medicine_name=${encodeURIComponent(medicine_name)}`)
      .then(response => response.json())
      .then(result => {
        if (result && result.length > 0) {
          group.push(medicine_name);
          this.show_preview();
          input.value = '';
          errorEl.innerHTML = '';
        } else {
          errorEl.innerHTML = `<p>药名 ${medicine_name} 不存在</p>`
        }
      })
      .catch(error => {
        console.error('Error:', error);
        errorEl.innerHTML = `<p>查询药名时出错</p>`
      });
  }

  add1() {
    this.add(this.group1, 'medicine_name')
  }

  add2() {
    this.add(this.group2, 'medicine_name_2')
  }

  save() {
    const antipatternname = this.element.querySelector('[data-anti-pattern-target="antipatternname"]');
    const errorEl = this.element.querySelector('[data-anti-pattern-target="error"]');
    const notes = this.element.querySelector('[data-anti-pattern-target="notes"]');

    if (!antipatternname.value.trim()) {
      errorEl.innerHTML = `<p>禁忌名称不能为空</p>`
      return;
    }

    // Get CSRF token from meta tag
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    const formData = new FormData();
    formData.append("authenticity_token", csrfToken);
    formData.append("anti_pattern[name]", antipatternname.value.trim());
    formData.append("anti_pattern[notes]", notes.value);
    formData.append("anti_pattern[group1]", this.group1.join(','));
    formData.append("anti_pattern[group2]", this.group2.join(','));

    fetch("/anti_patterns", {
      method: 'POST',
      body: formData
    })
      .then(response => {
        if (response.ok) {
          // Redirect to anti_patterns list on success
          window.location.href = '/anti_patterns';
        } else {
          return response.text().then(text => {
            throw new Error(`Server error: ${response.status} - ${text}`);
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        errorEl.innerHTML = `<p>保存禁忌规则时出错: ${error.message}</p>`;
      });
  }

}
